export default class StyleHelper {

  constructor () {
    this.borderStyle = {
      style: 'solid',
      width: '1px ',
      color: '#EaEaEa'
    }
    this.styles = {}
  }

  background (value) {
    this.styles.background = value
    return this
  }

  backgroundColor (value) {
    this.styles.backgroundColor = value
    return this
  }

  color (value) {
    this.styles.color = value
    return this
  }

  padding (y, x) {
    this.styles.paddingLeft = x + 'px'
    this.styles.paddingRight = x + 'px'
    this.styles.paddingTop = y + 'px'
    this.styles.paddingBottom = y + 'px'
    return this
  }

  overflowX (value) {
    this.styles.overflowX = 'hidden'
    return this
  }

  width (value) {
    this.styles.width = value
    return this
  }

  minWidth (value) {
    this.styles.minWidth = value
    return this
  }

  fill (value) {
    this.styles.fill = value
    return this
  }

  stroke (value) {
    this.styles.stroke = value
    return this
  }

  strokeWidth (value) {
    this.styles.strokeWidth = value
    return this
  }

  fontSize (value) {
    this.styles.fontSize = value
    return this
  }

  fontWeight (value) {
    this.styles.fontWeight = value
    return this
  }

  fontFamily (value) {
    this.styles.fontFamily = value
    return this
  }

  border (value = false, width = this.borderStyle.width, style = this.borderStyle.style, color = this.borderStyle.color) {
    if (value === false) {
      this.styles.borderWidth = 0
      return this
    }

    this.styles.borderWidth = this.getBorderWidthAsString(value)
    this.styles.borderStyle = style
    this.styles.borderColor = color
    return this
  }

  height (value) {
    this.styles.height = value
    return this
  }

  minHeight (value) {
    this.styles.minHeight = value
    return this
  }

  get () {
    return this.styles
  }

  getBorderWidthAsString (sides = 'all', width = this.borderStyle.width) {
    if (sides === 'all') return width

    let borders = [
      sides.includes('top') ? width : 0,
      sides.includes('right') ? width : 0,
      sides.includes('bottom') ? width : 0,
      sides.includes('left') ? width : 0
    ]

    return borders.join(' ')
  }

}



// WEBPACK FOOTER //
// ./styles.js